<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from 'vue-good-table';
const dropdownsApi = ClientFactory.get("dropdowns");

const emulationApi = ClientFactory.get("emulations");

export default {
  components: {
      VueGoodTable
  },
  data(){
    return {
      total: 0,
      emulation_delete_id: 0,
      emulation_group_id:0,
      department_id: null,
      employee_id: null,
      full_name:'',
      year: new Date().getFullYear(),
      currentMonth: new Date().getMonth()+1,
      note:"",
      columns: [
        {
          label: 'Trạng thái',
          field: 'approver_status_name',
          thClass: 'emu-vgt-thead-th text-center ',
          tdClass: 'emu-vgt-tbody-td text-center',
          width: '110px',
        },
        {
          label: 'Tháng',
          field: 'time',
          thClass: 'emu-vgt-thead-th text-center ',
          tdClass: 'emu-vgt-tbody-td text-center ',
        },
        {
          label: 'Họ và Tên',
          field: 'full_name',
          thClass: 'emu-vgt-thead-th text-center',
          tdClass: 'emu-vgt-tbody-td',
        },
        // {
        //   label: 'Chức vụ',
        //   field: 'position_name',
        //   thClass: 'emu-vgt-thead-th text-center width-point',
        //   tdClass: 'emu-vgt-tbody-td text-center width-point',
        // },
        {
          label: 'Điểm cá nhân chấm',
          field: 'total_point_self_rating',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
        },
        {
          label: 'Điểm phòng chấm',
          field: 'total_point_department_rating',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
        },
        {
          label: 'Xếp loại',
          field: 'graded',
          thClass: 'emu-vgt-thead-th text-center width-status',
          tdClass: 'emu-vgt-tbody-td text-center width-status',
        },
        {
          label: 'Thao tác',
          field: 'action',
          thClass: 'emu-vgt-thead-th text-center',
          tdClass: 'emu-vgt-tbody-td text-center',
          width: '105px',
        },
        
      ],
       data: [],
      group_emulation:[],
      years: [],
      months: [
        {
          value: 1,
          label: "Tháng 1",
        },
        {
          value: 2,
          label: "Tháng 2",
        },
        {
          value: 3,
          label: "Tháng 3",
        },
        {
          value: 4,
          label: "Tháng 4",
        },
        {
          value: 5,
          label: "Tháng 5",
        },
        {
          value: 6,
          label: "Tháng 6",
        },
        {
          value: 7,
          label: "Tháng 7",
        },
        {
          value: 8,
          label: "Tháng 8",
        },
        {
          value: 9,
          label: "Tháng 9",
        },
        {
          value: 10,
          label: "Tháng 10",
        },
        {
          value: 11,
          label: "Tháng 11",
        },
        {
          value: 12,
          label: "Tháng 12",
        },
      ],
      departments:[]
    };
  },
  async created() {
    this.department_id= this.AppActiveUser.department_id;
    this.employee_id= this.AppActiveUser.employee_id;
    this.years = await dropdownsApi.get(dropdownsApi.type.YEARS);
    this.departments = await dropdownsApi.get(dropdownsApi.type.DEPARTMENTS);

    await this.getEmulationGroup();
    ({
        year:this.year,
        currentMonth:this.currentMonth,
        full_name:this.full_name,
        department_id:this.department_id,
        emulation_group_id:this.emulation_group_id
      } = this.filterVPTH);
    this.getEmulation();
  },
  methods: {
    ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    ...mapActions("EmulationStore", ["saveVPTHSearchFilter"]),
    getEmulation: async function () {
      this.loading(this.$vs);

      this.saveVPTHSearchFilter({
        filter: {
          year:this.year,
          currentMonth:this.currentMonth,
          full_name:this.full_name,
          department_id:this.department_id,
          emulation_group_id:this.emulation_group_id
        },
      });

      const { data } = await emulationApi.getEmulationOffice(
        this.year,
        this.currentMonth,
        this.full_name,
        this.department_id,
        this.emulation_group_id,
      );
      this.closeLoading();
      this.checkResponseData(data);
    },

    getEmulationGroup: async function () {
      const { data } = await emulationApi.getGroupByEmployee(this.employee_id);
      
      if(data.status == "success")
      { 
          if(data.data[0].groups != null) {
            this.emulation_group_id = data.data[0].groups[0].value;
            this.group_emulation = data.data[0].groups;
            this.saveVPTHSearchFilter({
                filter: {
                  ...this.filterVPTH,
                  emulation_group_id:this.emulation_group_id
                },
              });

          }else
          {
            this.group_emulation =[];
          } 
      }
    },

    checkResponseData(data) {
      if(data.status == "success")
      { 
        if(data.data[0].id != undefined)
          this.data = data.data;
        else
          this.data = [];

      }else{
        this.notify({
          error:true,
          title: "Thông báo",
          text: data.message
        });
      }
     },

    rowStyleClassFn(row) {
      return row.is_title > 0 ? 'header-row' : '';
    },
    goDetailEmulation(emulationId) {
        this.$router.push({path: `detail/${emulationId}`}).catch(() => {});
    },
    searchEmulation(){
      this.getEmulation();
    },
    /**
     * Tải bản chấm công (excel)
     */
    downloadReport: async function() {
      this.loading(this.$vs);
      const response = await emulationApi.downloadOfficeSummaryReport(this.department_id,this.year, this.currentMonth, this.emulation_group_id);
      this.closeLoading();
      
      if(typeof response === 'undefined' || response.status === 'failed') {
          return this.notify({
              error: true,
              text: response.message || "Unknow error",
          })
      }
      //console.log(response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `van_phong_tong_hop_thi_dua_${this.currentMonth}_${this.year}.xlsx`)
      link.click();
      window.URL.revokeObjectURL(url);
      
    },
    async saveDepartmentRating(id,approver_status) {
      //send to server
      let response = await emulationApi.updateApproverStatus({
        id: id,
        approver_status: approver_status
      });
      console.log(response);
      if(response.data.status === 'failed') {
          return this.notify({
              error: true,
              text: response.error || response.data.message,
          })
      }
      if(response.data.status === 'success') {
          this.notify({
              success: true,
              text: response.data.data[0].error_message,
          });
      }
      this.getEmulation();
     },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    ...mapGetters("EmulationStore", ["filterVPTH"]),
  },
  destroyed() {
    this.closeLoading();
  }
};

</script>

<template>
  <div class="general_office_report">
    <CCard title="Văn phòng tổng hợp chấm điểm" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
           <span class="card-header-title">Văn phòng tổng hợp chấm điểm</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow class="mt-2">
          <CCol sm="2">
              <label class='mb-0'>Họ và tên</label>
              <CInput
                :value.sync="full_name"
                class=" pt-1"
                />
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>Năm</label>
              <CSelect
                :options=years
                :value.sync="year"
                class=" pt-1"
                @change="getEmulation"
              />
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>Tháng</label>
              <CSelect
                :options=months
                :value.sync="currentMonth"
                class="pt-1"
                @change="getEmulation"
              />
            </CCol>
            <CCol sm="3">
              <label class='mb-0'>Phòng ban</label>
              <CSelect
                :options=departments
                :value.sync="department_id"
                class=" pt-1"
                @change="getEmulation"
              />
            </CCol>
            <CCol sm="3">
              <label class='mb-0'>Nhóm thi đua</label>
              <CSelect
                :options=group_emulation
                :value.sync="emulation_group_id"
                class="pt-1"
                @change="getEmulation"
              />
              </CCol>
        </CRow>
        <CRow>
            <CCol sm="12" class="center">
              <vs-button warn square class="custom_btn_search"  @click="searchEmulation()"><i class='bx bx-search'></i>Tìm kiếm</vs-button>
            </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
        <vue-good-table
          :columns="columns"
          :rows="data"
          compactMode
          :sort-options="{
            enabled:false
          }"
          :pagination-options="{
              enabled: true,
              perPage: 100,
              perPageDropdownEnabled: false,
              nextLabel: 'Trang sau',
              prevLabel: 'Trang trước',
              ofLabel: 'của',
          }"
          :line-numbers="true"
          :row-style-class="rowStyleClassFn"
        >
          <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
            Không có dữ liệu
          </div>
          <template
            slot="table-row"
            slot-scope="props"
          >
              <div v-if="props.column.field === 'approver_status_name'">
                  <CBadge v-if="props.row.approver_status == 1" color="success">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else-if="props.row.approver_status == 0" color="warning">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else-if="props.row.approver_status == 4" color="warning">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else-if="props.row.approver_status == 5" color="warning">{{props.row.approver_status_name}}</CBadge>
                  <CBadge v-else color="danger">{{props.row.approver_status_name}}</CBadge>
              </div>
              <div v-else-if="props.column.field === 'total_point_department_rating'">
                  <span v-if="props.row.total_point_department_rating >0">{{props.row.total_point_department_rating}}</span>
                  <span v-else>--</span>
              </div>
              <div v-else-if="props.column.field === 'graded'">
                  <span v-if="props.row.graded != null">{{props.row.graded}}</span>
                  <span v-else>--</span>
              </div>
              <div v-else-if="props.column.field === 'action'">
                  <!-- Trạng thái đã duyệt mới có nút trả lại -->
                  <div v-if="props.row.approver_status === 1"  class="row">
                      <vs-tooltip color="square">
                          <!-- <vs-button transparent @click="goDetailEmulation(props.row.id)" square circle icon><i class='bx bxs-info-circle'></i></vs-button> -->
                          <template #tooltip>
                              Xem chi tiết bảng chấm điểm
                          </template>
                          <vs-button
                            @click="goDetailEmulation(props.row.id)"
                            primary
                            square
                            size="mini"
                          >Chi tiết</vs-button>
                      </vs-tooltip>
                      <vs-tooltip  color="danger">
                        <!-- <vs-button transparent @click="saveDepartmentRating(props.row.id,5)"  danger circle icon><i class='bx bx-log-out-circle' ></i></vs-button> -->
                          <template #tooltip>
                              Trả lại để lãnh đạo phê duyệt lại.
                          </template>
                          <vs-button
                            @click="saveDepartmentRating(props.row.id,5)"
                            danger
                            square
                            size="mini"
                          >Trả lại</vs-button>
                      </vs-tooltip>
                  </div>
                  <div v-else  class="row">
                      <vs-tooltip color="square">
                          <!-- <vs-button transparent @click="goDetailEmulation(props.row.id)" square circle icon><i class='bx bxs-info-circle'></i></vs-button> -->
                          <template #tooltip>
                              Xem chi tiết bảng chấm điểm
                          </template>
                          <vs-button
                            @click="goDetailEmulation(props.row.id)"
                            primary
                            square
                            size="mini"
                          >Chi tiết</vs-button>
                      </vs-tooltip>
                  </div>
              </div>
              
          </template>
        </vue-good-table> 
        <CRow>
          <CCol sm="12" class="" style="margin-top:10px">
            <vs-button
              success
              square
              :disabled="this.data.length===0"
              @click="downloadReport()"
            >
              <i class="bx bxs-download"></i>&nbsp;Tải về</vs-button
            >
          </CCol>
      </CRow>
    </CCard>
  </div>
</template>

<style lang="scss">
  .general_office_report{
    table.vgt-table td {
      vertical-align: inherit;
      padding: 0em .75em .0em .75em;
    }
    .vgt-responsive {
        overflow-x: inherit;
    }
    .width-class{
      min-width: 3px !important;
    }
    .width-status{
      min-width: 10px !important;
    }
  }
</style>